/*
  Drag-to-scroll for horizontal carousels.

  Note: this file previously had unbalanced parentheses on the last line, which
  meant the whole script failed to parse and threw a console error on every
  page. It also passed an element where a selector string was expected.
*/
(function () {
  const touchFunction = function (selector) {
    const carousel =
      typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!carousel) return;

    let startX;
    let isDragging = false;

    carousel.addEventListener('mousedown', (e) => {
      startX = e.pageX;
      isDragging = true;
    });

    carousel.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const moveX = e.pageX - startX;
      carousel.scrollLeft -= moveX;
      startX = e.pageX;
    });

    carousel.addEventListener('mouseup', () => {
      isDragging = false;
    });

    carousel.addEventListener('mouseleave', () => {
      isDragging = false;
    });

    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
      isDragging = true;
    });

    carousel.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const moveX = e.touches[0].pageX - startX;
      carousel.scrollLeft -= moveX;
      startX = e.touches[0].pageX;
    });

    carousel.addEventListener('touchend', () => {
      isDragging = false;
    });
  };

  document
    .querySelectorAll('[data-touch-scroll]')
    .forEach((el) => touchFunction(el));
})();
